import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative w-full py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Luxury%20casino%20golden%20chandelier%20with%20dark%20elegant%20background%2C%20warm%20glowing%20lights%2C%20premium%20interior%2C%20sophisticated%20atmosphere%2C%20dramatic%20lighting%2C%20abstract%20bokeh%20effect%2C%20no%20people&width=1920&height=800&seq=cta-bg-casino&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          准备好开始您的娱乐之旅了吗？
        </h2>
        <p className="text-base md:text-lg text-white/70 max-w-lg mx-auto mb-8 leading-relaxed">
          立即加入新葡京娱乐城，享受顶级娱乐体验与丰厚奖金回馈
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors text-base whitespace-nowrap cursor-pointer"
          >
            立即注册
          </a>
          <Link
            to="/about"
            className="px-8 py-3.5 border border-white/40 text-white font-medium rounded-md hover:bg-white/10 transition-colors text-base whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}